import Swal from 'sweetalert2';
import themeConfig from '../theme/themeConfig';

function getIconType(type) {
  switch (type) {
    case 'alert-success':
      return `
				<div class="flex justify-center mb-5">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x=".5" y=".5" width="39" height="39" rx="5.5" fill="#DEF2DA" stroke="#52A728"/>
						<path d="m13.333 20 4.293 4.293a1 1 0 0 0 1.415 0l7.626-7.626" stroke="#52A728" stroke-width="1.5" stroke-linecap="round"/>
					</svg>
				</div>`;
    case 'alert-error':
      return `
				<div class="flex justify-center mb-5">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x=".5" y=".5" width="39" height="39" rx="5.5" fill="${themeConfig.appPrimaryColorExtraLight}" stroke="${themeConfig.appPrimaryColorDeep}"/>
						<path d="m15 15 10 10M25 15 15 25" stroke="${themeConfig.appPrimaryColorDeep}" stroke-width="1.5" stroke-linecap="round"/>
					</svg>
				</div>`;
    case 'alert-question':
      return `
				<div class="flex justify-center mb-5">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x=".5" y=".5" width="39" height="39" rx="5.5" fill="#D5E6FB" stroke="#2F80ED"/>
						<path d="M18.919 23.365c0-.977.18-1.803.54-2.479.36-.675.883-1.412 1.568-2.211.522-.622.91-1.146 1.162-1.573.252-.426.379-.906.379-1.439 0-.604-.217-1.074-.65-1.412-.431-.355-1.035-.533-1.81-.533-.775 0-1.595.169-2.46.506-.846.338-1.684.818-2.513 1.44L14 13.158c.739-.658 1.694-1.182 2.865-1.573A11.04 11.04 0 0 1 20.378 11c1.1 0 2.072.187 2.92.56.846.355 1.504.87 1.972 1.545.487.657.73 1.412.73 2.265 0 .924-.225 1.732-.676 2.425-.45.693-1.099 1.457-1.946 2.292-.738.782-1.297 1.421-1.675 1.919a3.75 3.75 0 0 0-.676 1.705l-.108.72h-2v-1.066zm-.838 2.958h3.784V30H18.08v-3.677z" fill="#2F80ED"/>
					</svg>
				</div>`;
    default:
      return `
				<div class="flex justify-center mb-5">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x=".5" y=".5" width="40" height="39" rx="5.5" fill="${themeConfig.appPrimaryColorExtraLight}" stroke="${themeConfig.appPrimaryColorDeep}"/>
						<path d="m15 15 10 10M25 15 15 25" stroke="${themeConfig.appPrimaryColorDeep}" stroke-width="1.5" stroke-linecap="round"/>
					</svg>
				</div>`;
  }
}

async function showAlert(alertData) {
  const iconType = getIconType(alertData.iconType);
  const { value: accept } = await Swal.fire({
    title: alertData.title ? alertData.title : null,
    html: alertData.html ? `${iconType}${alertData.html}` : null,
    text: alertData.text ? alertData.text : null,
    type: alertData.type ? alertData.type : null,
    showCloseButton: alertData.showCloseButton
      ? alertData.showCloseButton
      : false,
    showCancelButton: alertData.showCancelButton
      ? alertData.showCancelButton
      : false,
    confirmButtonColor: alertData.confirmButtonColor
      ? alertData.confirmButtonColor
      : null,
    cancelButtonColor: alertData.showCancelButton
      ? alertData.cancelButtonColor
        ? alertData.cancelButtonColor
        : themeConfig.appPrimaryColor
      : null,
    cancelButtonText: alertData.cancelButtonText
      ? alertData.cancelButtonText
      : null,
    confirmButtonText: alertData.confirmButtonText
      ? alertData.confirmButtonText
      : null
  });

  return accept;
}

export default showAlert;
